<ng-container *ngIf="notice as current">
  <div class="notice-scrim" *ngIf="current.blockWork && !leaving" aria-hidden="true"></div>
  <div class="notice-position" [class.is-leaving]="leaving">
    <section class="notice-banner" [class.is-blocking]="current.blockWork"
      [attr.role]="current.blockWork ? 'alertdialog' : 'status'"
      [attr.aria-modal]="current.blockWork ? 'true' : null"
      [attr.aria-label]="current.title" aria-live="assertive">
      <div class="notice-accent"></div>
      <div class="notice-content">
        <div class="notice-symbol" aria-hidden="true">{{ current.blockWork ? '!' : 'i' }}</div>
        <div class="notice-copy">
          <div class="notice-meta">
            <span class="notice-label">{{ current.blockWork ? 'Important update' : 'Announcement' }}</span>
            <span class="notice-client" *ngIf="clientName">{{ clientName }}</span>
          </div>
          <h2>{{ current.title }}</h2>
          <p>{{ current.message }}</p>
          <div class="notice-footer" *ngIf="!current.blockWork">
            <button type="button" class="notice-action" (click)="dismiss()">
              {{ current.closeAllowed ? 'Got it' : 'Read and continue' }}
            </button>
          </div>
        </div>
        <button *ngIf="current.closeAllowed && !current.blockWork" class="notice-close" type="button"
          aria-label="Close notice" (click)="dismiss()">&times;</button>
      </div>
    </section>
  </div>
</ng-container>
